import FormBox from '../common/FormBox/FormBox';
import styles from './termsOfUse.module.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TermsOfUseTemplate from './TermsOfUseTemplate';
import ReactGA from 'react-ga4';

export default function TermsOfUse() {
    const [agreed, setAgreed] = useState<boolean>(false);
    // const [validationMsg, setValidationMsg] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: `${window.location.pathname}`,
            title: 'TermsOfUse',
        });
    }, []);

    const handleAgree = () => {
        setAgreed(!agreed);
        navigate('/provider_overview');
    };
    // FIELD VALIDATION
    const validate = (field: string, value: string) => {
        const validated = true;
        return validated;
    };

    return (
        <FormBox validation={validate} tableNames={[]} data={[]}>
            <div>
                <TermsOfUseTemplate />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                        style={{ padding: 10, marginTop: 15 }}
                        className={`footer-action-btn ${styles.button}`}
                        onClick={handleAgree}
                    >
                        I agree
                    </button>
                </div>
            </div>
        </FormBox>
    );
}
